import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=8f07a374&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"
import style0 from "./Save.vue?vue&type=style&index=0&id=8f07a374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f07a374",
  null
  
)

export default component.exports